<template>
  <div>
    <h3 class="student-subaccount-box--title mb-3">
      {{ $t("bookedClasses") }}
    </h3>

    <v-data-table
      :headers="headersTitles"
      :items="upcommingSessions"
      item-key="id"
      class="elevation-1"
      :items-per-page="10"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50, 100],
      }"
    >
      <template v-slot:body="{ items }">
        <tbody v-if="upcommingSessions.length">
          <tr v-for="item in items" :key="item.session_id">
            <td class="text-xs-right">{{ item.course_type }}</td>
            <td class="text-xs-right">{{ item.start_date }}</td>
            <td class="text-xs-right">{{ item.start_time }}</td>
            <td class="text-xs-right">{{ item.session_fee }}</td>
            <td class="text-xs-right">{{ item.program.name }}</td>
            <td class="text-xs-right">
              {{
                item.tutor
                  ? `${item.tutor.first_name} ${item.tutor.last_name}`
                  : "NA"
              }}
            </td>
            <td class="action-column">
              <button
                v-if="
                  isSessionTime(item) && (!inMeeting || inMeeting == 'false')
                "
                class="btn-round add-student-btn"
                type="button"
                @click="startZoomMeeting(item.zoom_meeting.zoom_meeting_number)"
              >
                {{ $t("joinClass") }}
              </button>

              <button
                v-else
                disabled
                class="btn-round add-student-btn disabled-btn"
                type="button"
                @click="startZoomMeeting(item.zoom_meeting.zoom_meeting_number)"
              >
                {{ $t("joinClass") }}
              </button>

              <button
                v-if="
                  isSessionTime(item) && (!inMeeting || inMeeting == 'false')
                "
                class="btn-round add-student-btn"
                type="button"
                @click="joinOnZoom(item.zoom_meeting.zoom_meeting_number)"
              >
                {{ $t("joinClassZoom") }}
              </button>

              <button
                v-else
                disabled
                class="btn-round add-student-btn disabled-btn"
                type="button"
                @click="joinOnZoom(item.zoom_meeting.zoom_meeting_number)"
              >
                {{ $t("joinClassZoom") }}
              </button>
              <button
                class="btn-round add-student-btn"
                type="button"
                @click="showReScheduleDialog(item)"
              >
                {{ $t("reschedule") }}
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td :colspan="headersTitles.length" style="text-align: center">
              {{ $t("noResultsHere") }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <v-dialog  transition="dialog-bottom-transition"
      max-width="1400"
      v-model="reScheduleDialog"
      v-if="reScheduleDialog">
    <v-card>
				<v-card-title>
					<span class="text-h3">
							{{ $t("rescheduleSession") }}
					</span>
					<v-spacer></v-spacer>
					<v-btn
						class="mx-2 btn-round"
						small
						color="primary"
						@click="hideReScheduleDialog"
					>
						<v-icon dark>
							mdi-window-close
						</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="card-content">
          <SessionsView :id="tutorId"/>
        </v-card-text>
        <v-card-actions class="actions-btn-group pe-6">
          <v-btn class="action-btn" color="green lighten-1" @click="reSchedule">{{ $t("reschedule") }}</v-btn>
          <v-btn class="action-btn" color="red darken-3" @click="hideReScheduleDialog">{{ $t("Cancel") }}</v-btn>
        </v-card-actions>
    </v-card>    
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment-timezone";
import GlobalMixin from "@/GlobalMixin.js";
import SessionsView from "@/views/NewReservation/SessionsView.vue";

export default {
  mixins: [GlobalMixin],
  data() {
    return {
      todayDate: "",
      timeNow: "",
      dataBody: {},
      upcommingSessions: [],
      inMeeting: false,

      reScheduleDialog: false,
      tutorId: null,
      studentId: null,
      startDateTime: '',
      endDateTime: '',
    };
  },
  components: {
    SessionsView
  },
  mounted() {
    this.inMeeting = window.localStorage.getItem("inMeeting");
    window.addEventListener("storage", () => {
      this.inMeeting = window.localStorage.getItem("inMeeting");
    });
  },
  async created() {
    var date = new Date();
    var options = { hour12: false };
    var CurrentTime = date.toLocaleString("en-US", options);
    var time = CurrentTime.split(",")[1].split(":")[0];

    this.todayDate = moment().format("Y-MM-DD");

    if (time == 24) {
      this.timeNow = time - 24;
    } else {
      this.timeNow = CurrentTime.split(",")[1].trim();
    }

    await this.getTodayClasses();
  },
  methods: {
    async getTodayClasses() {
      var today = new Date();
      var todayDate =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      //this.dataBody.from_date = todayDate;
      // this.dataBody.to_date = todayDate;
      let upcomingsUrl = process.env.VUE_APP_APIEndPoint + "reserve/upcomings/";
      let response = await this.axios.post(
        upcomingsUrl,
        this.dataBody,
        this.headers
      );
      // if(response.status == 401){
      //   let response = await this.axios.post(
      //   process.env.VUE_APP_APIEndPoint+'auth/refresh_token/',
      //   this.dataBody,
      //   this.headers
      // );
      // }
      if (response) {
        this.upcommingSessions = response.data.data.upcoming_sessions;
      } else {
        console.log("error while getting tutor current classes....");
      }
    },
    async startZoomMeeting(item) {
      var user = this.$store.getters.StateUser?.user;
      let userId = user.id;
      let uid = btoa(userId.toString());
      let meetingId = item;
      let mid = btoa(meetingId.toString());
      this.$router.push({ name: "meeting", query: { uid: uid, mid: mid } });
    },

    joinOnZoom(item) {
      var user = this.$store.getters.StateUser?.user;
      let userId = user.id;
      let uid = btoa(userId.toString());
      let meetingId = item;
      let mid = btoa(meetingId.toString());
      let data = {
        uid,
        mid,
      };
      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}reserve/meeting/`,
          data,
          this.headers
        )
        .then((response) => {
          if (response) {
            window.open(response.data.data.zoom_meeting.join_meeting_url);
          }
        });
    },
    isSessionTime(item) {
      let startTimestamp = moment(`${item.start_date} ${item.start_time}`)
        .tz(this.headers.headers["USER-TIMEZONE"])
        .unix();
      let endTimestamp = moment(`${item.end_date} ${item.end_time}`)
        .tz(this.headers.headers["USER-TIMEZONE"])
        .unix();
      let currentTimestamp = moment(
        `${moment()
          .tz(this.headers.headers["USER-TIMEZONE"])
          .format("D/M/Y HH:mm:ss")}`,
        "D/M/Y HH:mm:ss"
      ).unix();
      return (
        currentTimestamp >= startTimestamp && currentTimestamp <= endTimestamp
      );
    },
    /**
     * Show reSchedule dialog and assign tutorID,startDateTime and endDateTime
     * @param {*sessionObject} item 
     */
    showReScheduleDialog(item) {
      this.reScheduleDialog = true;
      this.tutorId = item.tutor.id;
      this.studentId = item.student.id;
      this.startDateTime = `${item.start_date} ${item.start_time}`
      this.endDateTime = `${item.end_date} ${item.end_time}`
    },
    hideReScheduleDialog() {
      this.reScheduleDialog = false;
      this.tutorId = null;
      this.studentId = null;
      this.startDateTime = ' ';
      this.endDateTime = ' ';
      this.$store.dispatch("removeSelectedSlot");
    },
    /**
     * Re-schedule Session
     */
    reSchedule() {
      if(!this.$store.getters.GET_SELECTED_SLOTS[0]) {
        return this.showAlert('Please select a slot to re-schedule!', "error");
      }

      const body = {
        tutor: this.tutorId,
        student: this.studentId,
        existing_slot: {
          start_date_time: this.startDateTime,
          end_date_time: this.endDateTime
        },
        requested_slot: {
          start_date_time: this.$store.getters.GET_SELECTED_SLOTS[0].start_date_time,
          end_date_time: this.$store.getters.GET_SELECTED_SLOTS[0].end_date_time
        }
      }

      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}reserve/session/reschedule/`,
          body,
          this.headers
        ).then(
          (res) => this.showAlert(res.data.data.message, "success")
        ).catch(
          (err) => this.formatErrors(err)
        );

        this.hideReScheduleDialog()
    }
  },
  computed: {
    headersTitles() {
      return [
        { text: this.$t("course_Type"), value: "CourseType", sortable: false },
        { text: this.$t("Start_Date"), value: "startDate", sortable: false },
        { text: this.$t("Start_Time"), value: "startTime", sortable: false },
        { text: this.$t("Fees"), value: "fees", sortable: false },
        {
          text: this.$t("programName"),
          value: "programeName",
          sortable: false,
        },
        { text: this.$t("tutorName"), value: "tutortName", sortable: false },
        { text: this.$t("Action"), value: "action", sortable: false },
      ];
    },
  },
};
</script>
<style scoped lang="scss">
.btn-round {
  padding: 4px 10px;
}

.disabled-btn,
.disabled-btn:hover {
  background-color: #c0c5be;
}

.action-column {
  display: flex;
  gap: 5px;
}

.card-content{
  margin-top: -2rem;
}

.actions-btn-group{
  display: flex;
  justify-content: center;
  gap: 2rem;
}

.action-btn{
  color: #fff;
}
</style>
